<template>
  <div class="card-body">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CardBody'
}
</script>

<style scoped lang="scss">
.card-body {
  height: calc(100vh - #{$main-header-height} - #{$body-gap} * 2);
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 14px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: white;
  transition: 0.3s;
  color: #303133;
}
</style>
